<template>
  <th class="tree-grid-column" :style="[widthStyle]">
    {{ title }}
    <slot name="item"></slot>
  </th>
</template>

<script>
export default {
  name: 'TreeGridColumn',
  props: {
    title: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: undefined,
      required: false
    },
    align: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    widthStyle () {
      if (this.size) {
        return `width: ${this.size};`
      }

      return undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treegrid/TreeGridColumn.vue